import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import Section from 'app/frontend/base/components/Section'
import { useAuth } from 'app/frontend/base/config/context/auth'
import { useTeam } from 'app/frontend/base/config/context/team'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useCopyToClipboard } from 'app/frontend/base/helpers/hooks'
import { gameVersionToSubdomain } from 'app/frontend/types/custom/GameVersion'
import { useTranslation } from 'react-i18next'
import SpreadsheetGetStarted from './components/SpreadsheetGetStarted'
import SpreadsheetExisting from './components/SpreadsheetExisting'

const TeamSpreadsheet = () => {
  const { team, guild } = useTeam()
  const { t } = useTranslation()
  const {
    data: { gameVersion },
  } = usePageInfo()

  const { accessLevel } = useAuth()
  const { copied, copyToClipboard } = useCopyToClipboard()

  return (
    <Section
      title={`Spreadsheet | ${team.name} | ${guild.name}`}
      className='max-w-3xl'
    >
      <h2>Spreadsheet</h2>
      <div>
        Insights into your team&apos;s characters are exposed in an extensive
        spreadsheet. Once set up, data in the spreadsheet will be updated
        automatically. To get a new spreadsheet, make a{' '}
        <a
          href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com/copy`}
          className='text-primary hover:text-primary/90'
          target='_blank'
          rel='noreferrer'
        >
          copy
        </a>{' '}
        and then{' '}
        {accessLevel === 'admin' ? (
          <span>
            paste the key
            <Tooltip>
              <TooltipTrigger
                onClick={() => copyToClipboard(team.readonlyKey ?? '')}
              >
                <code className='text-xs bg-muted rounded-md px-1 py-0.5 mx-1'>
                  {team.readonlyKey}
                </code>
              </TooltipTrigger>
              <TooltipContent>
                {copied
                  ? 'Copied!'
                  : t('dashboard.team.settings.click-to-copy')}
              </TooltipContent>
            </Tooltip>
            in the settings tab of your new spreadsheet.
          </span>
        ) : (
          <span>
            ask one of your team&apos;s admins to provide you with the
            spreadsheet key (found in the team settings).
          </span>
        )}
      </div>

      <div className='bg-muted rounded-md p-4 mt-4'>
        {team.spreadsheetPath ? (
          <SpreadsheetExisting />
        ) : (
          <SpreadsheetGetStarted />
        )}
      </div>

      <h3 className='mt-6'>Refresh status</h3>
    </Section>
  )
}

export default TeamSpreadsheet
